<template>
  <div v-if="article">
    <h1>{{ article.title }}</h1>
    <div class="content" v-html="article.content" ></div>
  </div>
  <div v-else>
    <p>文章加载失败...</p>
  </div>
</template>

<script>
import { articleDetail } from "@/api/article/index";

export default {
  name: 'ArticleDetail',
  data() {
    return {
      article: null,
    };
  },
  created() {
    // 获取动态路径中的 id 参数
    const articleId = this.$route.params.id;
    this.fetchArticleDetail(articleId);
  },
  methods: {
    async fetchArticleDetail(id) {
      try {
        const response = await articleDetail(id);  // 调用 API 获取文章数据
        console.log('获取文章数据成功:', response);  // 输出返回的数据
        this.article = response;
      } catch (error) {
        console.error('获取文章数据失败:', error);  // 捕获并输出 API 请求错误
      }
    }
  },
};
</script>

<style scoped>
h1{
  text-align: center;
  font-size: 5vw;
  font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
  color: brown;
  font-weight: 500;
  margin-top: 2vw;
}
.content{
  width: 95%;
  margin: 3vw auto;
}
.content /deep/ img {
  width:100%;
  height: auto ;
  display: block;
  margin: 2vw auto;
}


</style>